import React from 'react';

export const Plus = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 1V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M1 7L13 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
